
<template>
  <div class="launch-page">
    <HeaderMain />

    <main class="launch-page__main">
      <section class="launch-hero shell-section">
        <div class="launch-hero__frame shell-surface">
          <div class="launch-hero__copy">
            <span class="launch-hero__eyebrow">FOMO HOST</span>
            <h1>Lanza tu evento con una vitrina que vende, una operacion que ordena y una caja que escala.</h1>
            <p>
              Publica con una marca que convierte, cobra entradas con claridad, controla accesos en puerta,
              mueve codigos de promotores, protege tu revenue y sigue todo desde un panel hecho para organizadores.
            </p>

            <div class="launch-hero__actions">
              <router-link class="launch-hero__button launch-hero__button--primary" :to="{ name: 'event-creation' }">
                <i class="fas fa-rocket"></i>
                <span>Empezar mi evento</span>
              </router-link>
              <router-link class="launch-hero__button launch-hero__button--ghost" :to="{ name: 'preloader', query: { next: '/events' } }">
                <i class="fas fa-right-to-bracket"></i>
                <span>Ya soy organizador</span>
              </router-link>
            </div>

            <div class="launch-hero__pills">
              <span>Gana dinero con ticketing y promos</span>
              <span>Controla QR, listas y accesos</span>
              <span>Activa codigos de promotores</span>
            </div>
          </div>

          <aside class="launch-hero__panel">
            <div class="launch-stat-card">
              <small>Lo que resuelves con FOMO</small>
              <strong>Mas venta, mas orden, menos friccion.</strong>
              <p>
                Tu evento entra a revision, se aprueba con criterio comercial y luego se activa con soporte real.
              </p>
            </div>

            <div class="launch-proof-grid">
              <article>
                <span>01</span>
                <strong>Venta</strong>
                <p>Checkout claro, etapas, links privados y experiencia lista para convertir.</p>
              </article>
              <article>
                <span>02</span>
                <strong>Operacion</strong>
                <p>QR, asistencia, codigos, cortesias, promotores y lectura de accesos desde el panel.</p>
              </article>
              <article>
                <span>03</span>
                <strong>Control</strong>
                <p>Fees, medios de pago, finanzas y visibilidad comercial desde un solo workspace.</p>
              </article>
            </div>
          </aside>
        </div>
      </section>

      <section class="launch-section shell-section">
        <div class="launch-section__heading">
          <span>Por que te conviene</span>
          <h2>Una plataforma pensada para que al organizador le cierren los numeros y la operacion.</h2>
          <p>
            No es solo subir un flyer. Es abrir un sistema para vender mejor, coordinar equipos y seguir cada peso con mas criterio.
          </p>
        </div>

        <div class="launch-benefits-grid">
          <article class="launch-benefit-card">
            <i class="fas fa-wallet"></i>
            <h3>Monetiza mejor</h3>
            <p>Define etapas, controla fees, activa promos y deja que cada salida tenga una logica comercial clara.</p>
          </article>
          <article class="launch-benefit-card">
            <i class="fas fa-user-shield"></i>
            <h3>Controla accesos</h3>
            <p>Valida tickets, escanea QR, organiza puerta y evita improvisaciones cuando la gente ya esta entrando.</p>
          </article>
          <article class="launch-benefit-card">
            <i class="fas fa-bullhorn"></i>
            <h3>Mueve promotores</h3>
            <p>Entrega codigos, mide empuje por canal y convierte a tus aliados en una capa real de distribucion.</p>
          </article>
          <article class="launch-benefit-card">
            <i class="fas fa-chart-line"></i>
            <h3>Lee la venta en vivo</h3>
            <p>Revisa volumen, tickets, addons, protecciones y actividad diaria sin perder tiempo entre planillas.</p>
          </article>
        </div>
      </section>

      <section id="flujo" class="launch-section shell-section">
        <div class="launch-section__heading launch-section__heading--compact">
          <span>Flujo simple</span>
          <h2>Asi entra un evento nuevo a FOMO.</h2>
        </div>

        <div class="launch-flow-grid">
          <article>
            <strong>1. Validas tu correo</strong>
            <p>Si tu mail ya esta vinculado al workspace, entras con OTP. Si no existe, creas tu cuenta de organizador en el mismo flujo.</p>
          </article>
          <article>
            <strong>2. Cargas lo esencial</strong>
            <p>Nombre, portada, fecha, venue, categoria y configuracion comercial base para dejar el evento listo para revision.</p>
          </article>
          <article>
            <strong>3. Queda pendiente</strong>
            <p>Tu evento no se publica de inmediato. Entra a revision para cuidar calidad, operacion y salida comercial.</p>
          </article>
          <article>
            <strong>4. Se aprueba y te avisamos</strong>
            <p>Cuando el evento queda aprobado, recibes un mail claro con el siguiente paso para abrir venta y mover tu panel.</p>
          </article>
        </div>
      </section>

      <section class="launch-section shell-section">
        <div class="launch-showcase shell-surface">
          <div>
            <span class="launch-showcase__eyebrow">Hecho para crecer</span>
            <h2>Desde un showcase chico hasta una fecha grande, el sistema acompana la salida completa.</h2>
            <p>
              Usa links privados, tickets publicos, codigos seleccionados, control por acceso y una capa administrativa que te deja ajustar sin frenar la venta.
            </p>
          </div>

          <div class="launch-showcase__list">
            <span><i class="fas fa-check"></i> Etapas y boletos por evento</span>
            <span><i class="fas fa-check"></i> Codigos manuales, bulk e importacion</span>
            <span><i class="fas fa-check"></i> Finanzas, fees y medios de pago</span>
            <span><i class="fas fa-check"></i> Soporte para cortesia, promos y control de puerta</span>
          </div>
        </div>
      </section>

      <section class="launch-section shell-section">
        <div class="launch-cta shell-surface">
          <div>
            <span class="launch-cta__eyebrow">Listo para vender mejor</span>
            <h2>Sube tu evento, deja la base lista y nosotros lo revisamos para salir con fuerza.</h2>
            <p>
              Si ya tienes cuenta, entras y lanzas. Si aun no estas vinculado, el mismo flujo te crea como organizador y te deja avanzar sin vueltas.
            </p>
          </div>

          <div class="launch-cta__actions">
            <router-link class="launch-hero__button launch-hero__button--primary" :to="{ name: 'event-creation' }">
              <i class="fas fa-calendar-plus"></i>
              <span>Crear evento ahora</span>
            </router-link>
            <router-link class="launch-hero__button launch-hero__button--ghost" :to="{ name: 'preloader', query: { next: '/events' } }">
              <i class="fas fa-arrow-right"></i>
              <span>Entrar al workspace</span>
            </router-link>
          </div>
        </div>
      </section>
    </main>

    <FooterMain />
  </div>
</template>

<script>
import FooterMain from '@/components/FooterMain.vue'
import HeaderMain from '@/components/HeaderMain.vue'

export default {
  name: 'LaunchEventView',

  components: {
    HeaderMain,
    FooterMain,
  },
}
</script>

<style scoped>
.launch-page {
  min-height: 100vh;
}

.launch-page__main {
  display: grid;
  gap: 20px;
  padding-bottom: 18px;
}

.launch-hero {
  padding-top: 8px;
}

.launch-hero__frame,
.launch-showcase,
.launch-cta {
  overflow: hidden;
  padding: clamp(24px, 3vw, 34px);
  background:
    radial-gradient(circle at top left, rgba(79, 161, 172, 0.18), transparent 24%),
    radial-gradient(circle at 82% 18%, rgba(217, 188, 124, 0.1), transparent 24%),
    linear-gradient(145deg, rgba(8, 13, 19, 0.98), rgba(6, 10, 16, 0.94)) !important;
}

.launch-hero__frame {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(280px, 0.8fr);
  gap: 20px;
}

.launch-hero__copy,
.launch-hero__panel,
.launch-stat-card,
.launch-proof-grid,
.launch-benefit-card,
.launch-showcase,
.launch-cta {
  display: grid;
  gap: 16px;
}

.launch-hero__eyebrow,
.launch-section__heading span,
.launch-showcase__eyebrow,
.launch-cta__eyebrow {
  color: #d8e5ea;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.launch-hero__copy h1,
.launch-section__heading h2,
.launch-showcase h2,
.launch-cta h2 {
  margin: 0;
  color: #f3f6f7;
  font-family: 'Cormorant Garamond', serif;
  line-height: 0.94;
  letter-spacing: -0.04em;
}

.launch-hero__copy h1 {
  max-width: 11ch;
  font-size: clamp(3rem, 5vw, 5rem);
}

.launch-section__heading h2,
.launch-showcase h2,
.launch-cta h2 {
  font-size: clamp(2rem, 3vw, 3.2rem);
}

.launch-hero__copy p,
.launch-section__heading p,
.launch-benefit-card p,
.launch-flow-grid p,
.launch-showcase p,
.launch-cta p,
.launch-stat-card p,
.launch-proof-grid p {
  margin: 0;
  color: rgba(214, 225, 230, 0.8);
  font-family: 'Manrope', sans-serif;
  line-height: 1.65;
}

.launch-hero__actions,
.launch-cta__actions,
.launch-hero__pills,
.launch-showcase__list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.launch-hero__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 54px;
  padding: 0 20px;
  border-radius: 999px;
  border: 1px solid rgba(221, 230, 235, 0.14);
  color: #eff5f7;
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 700;
  text-decoration: none;
  transition: transform 0.18s ease, border-color 0.18s ease, background 0.18s ease;
}

.launch-hero__button--primary {
  background: linear-gradient(135deg, #4a9ea8, #d8a24c);
  border-color: transparent;
  color: #071015;
}

.launch-hero__button--ghost {
  background: rgba(255, 255, 255, 0.04);
}

.launch-hero__button:hover {
  transform: translateY(-1px);
}

.launch-hero__pills span,
.launch-showcase__list span {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid rgba(221, 230, 235, 0.12);
  background: rgba(255, 255, 255, 0.04);
  color: #edf3f5;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 0.82rem;
}

.launch-stat-card,
.launch-proof-grid article,
.launch-benefit-card,
.launch-flow-grid article {
  padding: 18px;
  border-radius: 24px;
  border: 1px solid rgba(221, 230, 235, 0.1);
  background: rgba(255, 255, 255, 0.03);
}

.launch-stat-card small,
.launch-proof-grid article span {
  color: rgba(216, 226, 230, 0.68);
  font-family: 'Space Grotesk', sans-serif;
  font-size: 0.75rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.launch-stat-card strong,
.launch-proof-grid article strong,
.launch-benefit-card h3,
.launch-flow-grid article strong {
  color: #f2f5f6;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 1.05rem;
}

.launch-proof-grid,
.launch-benefits-grid,
.launch-flow-grid {
  display: grid;
  gap: 14px;
}

.launch-benefits-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.launch-flow-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.launch-benefit-card i {
  width: 46px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(74, 158, 168, 0.24), rgba(216, 162, 76, 0.2));
  color: #f0f4f5;
}

.launch-section {
  display: grid;
  gap: 18px;
}

.launch-section__heading {
  display: grid;
  gap: 10px;
  max-width: 860px;
}

.launch-section__heading--compact {
  max-width: 620px;
}

.launch-showcase,
.launch-cta {
  grid-template-columns: minmax(0, 1fr) minmax(280px, 0.86fr);
  align-items: center;
}

@media (max-width: 1080px) {
  .launch-hero__frame,
  .launch-showcase,
  .launch-cta,
  .launch-benefits-grid,
  .launch-flow-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 760px) {
  .launch-hero__frame,
  .launch-showcase,
  .launch-cta,
  .launch-benefits-grid,
  .launch-flow-grid {
    grid-template-columns: 1fr;
  }

  .launch-hero__copy h1 {
    max-width: none;
  }
}
</style>
